import { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";
import { Box } from "@mui/material";

// Lets a page put its action buttons in the top bar. The layout wraps the page in the provider,
// the top bar renders the slot, and the page renders <HeaderActions>buttons</HeaderActions>.
const HeaderActionsContext = createContext(null);

export function HeaderActionsProvider({ children }) {
  const [target, setTarget] = useState(null);
  return (
    <HeaderActionsContext.Provider value={{ target, setTarget }}>
      {children}
    </HeaderActionsContext.Provider>
  );
}

export function HeaderActionsSlot() {
  const context = useContext(HeaderActionsContext);
  return (
    <Box
      ref={context?.setTarget}
      sx={{ display: "flex", alignItems: "center", gap: "16px" }}
    />
  );
}

export function HeaderActions({ children }) {
  const target = useContext(HeaderActionsContext)?.target;
  return target ? createPortal(children, target) : null;
}
